import styled from 'styled-components'

export const FormContainer = styled.form`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  min-height: ${(props => props.$showWarning ? '370px': '300px')};
  margin: 60px;
`;